<template>
  <div class="jf-window job-quotes">
    <a href="javascript:;" class="toggle open" @click="$emit('close')">QUOTES</a>
    <a href="javascript:;" class="plus" v-tooltip="'Add quote'" @click="showModalAdd = true">+</a>
    <ul v-if="JOB_QUOTES.length">
      <li v-for="(quote, index) in JOB_QUOTES" :key="index">
        <div class="details">
          <div class="no">#{{ quote.quote_number }}</div>
          <div class="name">
            <router-link :to="{name: 'quote', params: {quoteId: quote.id}}" class="black">{{ quote.name }}</router-link>
          </div>
          <span class="status" :class="quote.status">{{ quote.status | statusToUCWords }}</span>
        </div>
        <div class="actions">
          <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate quote'" @click="confDuplicate(index)"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Delete quote'" @click="confDelete(index)"></a>
        </div>
      </li>
    </ul>
    <div v-if="totalQuote" class="tt">
      TOTAL QUOTED: ${{ totalQuote | numberFormat }}
    </div>
    <modal-add-quote v-model="showModalAdd" :job="JOB" @added="onQuoteAdded"></modal-add-quote>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ServiceQuote from '@/services/quote'
  import ModalAddQuote from '@/components/quotes/ModalAddQuote'
  import ModalDuplicate from '@/components/quotes/ModalDuplicate';

  export default {
    components: {
      ModalAddQuote
    },
    data() {
      return {
        showModalAdd: false
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['JOB', 'JOB_QUOTES']),
      totalQuote: function () {
        let self = this, total = 0;
        for (var i in self.JOB_QUOTES) {
          total += self.JOB_QUOTES[i].total_value;
        }
        return total;
      }
    },
    created() {
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
      },
      onQuoteAdded(quote) {
        this.$store.dispatch('ADD_JOB_QUOTE', quote);
        this.$router.push({
          name: 'quote',
          params: {
            quoteId: quote.id
          }
        });
      },
      confDuplicate ( index ) {
        let self = this;
        self.JOB_QUOTES[index].client = self.JOB.client;
        self.$modal.show(ModalDuplicate, {
          index: index,
          quote: self.JOB_QUOTES[index],
          on_job_view: true
        }, {
          clickToClose: false,
          width: 592
        });
      },
      confDelete ( index ) {
        let self = this, item = self.JOB_QUOTES[index];
        if (item) {
          self.$dialog
            .confirm('Are you sure you want to delete quote <strong>' + item.name + '</strong>?', {
              html: true,
              loader: true,
              okText: "Yes, I'm sure",
              cancelText: "Cancel",
            })
            .then(dialog => {
              ServiceQuote.delete(item.id, function(resp){
                dialog.close();
                if (resp.status == 'FAILED') {
                  self.$notify({
                    type: 'error',
                    text: resp.error,
                  });
                } else {
                  self.JOB_QUOTES.splice(index, 1);
                  self.$notify({
                    type: 'success',
                    text: 'Quote <strong>' + item.name + '</strong> has been deleted'
                  });
                  self.$store.dispatch('GET_JOB', self.JOB.id);
                }
              });
            })
            .catch(() => {})
          ;
        }
      },
    }
  }
</script>
